import { useState, useEffect, useCallback } from 'react';
import axios from 'src/axios';
import { APICONSTANTS } from 'src/components/Constants';

export default function usePersonLinkStatus(familyMemberId) {
  const [status, setStatus] = useState(null);
  const [linkData, setLinkData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchStatus = useCallback(async () => {
    if (!familyMemberId) return;
    setLoading(true);
    try {
      const url = APICONSTANTS.getPersonLinkStatus.replace(
        ':familyMemberId',
        encodeURIComponent(familyMemberId)
      );
      const { data } = await axios.get(url);
      setStatus(data.status);
      setLinkData(data);
    } catch {
      setStatus('none');
      setLinkData(null);
    } finally {
      setLoading(false);
    }
  }, [familyMemberId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { status, linkData, loading, refetch: fetchStatus };
}
